import { Routes } from '@angular/router'

import { OrganisationAdminRoutes } from './modules/workspaces/organisation-admin/organisation-admin-routes'
import { setOrganisationAdminWorkspaceGuard } from './modules/workspaces/organisation-admin/set-organisation-admin-workspace.guard'
import { WorkspaceRoutes } from './modules/workspaces/workspace/new-workspace-routes'
import { WorkspaceSelectActivator } from './modules/workspaces/workspace/workspace.resolvers'

export const AppGuardedRoutes: Routes = [
  {
    path: 'workspaces-select',
    canActivate: [WorkspaceSelectActivator],
    loadComponent: () =>
      import('./modules/workspaces/workspaces-select/workspaces-select.component').then(
        ({ WorkspacesSelectComponent }) => WorkspacesSelectComponent
      ),
  },

  // ORGANISATION ADMIN ROUTES
  // workspaces, fonts, designer users/roles, runtime users/roles/groups, task management, audit logs
  {
    path: 'organisation-admin',
    loadComponent: () =>
      import('./modules/workspaces/organisation-admin/organization-admin-main.component').then(
        ({ OrganizationAdminMainComponent }) => OrganizationAdminMainComponent
      ),
    canActivate: [setOrganisationAdminWorkspaceGuard],
    children: OrganisationAdminRoutes,
  },
  // WORKSPACE ROUTES
  // workspace entities: application/library, themes, fonts, media library, audit logs, users, groups
  {
    path: 'workspace/:workspaceId',
    children: WorkspaceRoutes,
  },

  // DESIGN SYSTEM SHOWCASE - not exposed in any menu, only for review purposes
  {
    path: 'design-system-showcase',
    canActivate: [setOrganisationAdminWorkspaceGuard],
    loadComponent: () =>
      import('./modules/design-system-showcase/design-system-showcase.component').then(
        (m) => m.DesignSystemShowcaseComponent
      ),
  },
]
